import {useEffect, useMemo, useState} from "react";

type FilterType = {
    filterData: any;
    filterKey: string;
    excludeInActive?: boolean;
}

const useFilter = (props: FilterType) => {
    const [ filterValue, setFilterValue ] = useState<string>('');
    const [ filterItems, setFilterItems ] = useState<Array<any>>([]);
    const [ filterReset, setFilterReset ] = useState<any>(null);

    const FilterData = (event: any) => {
        let val = event.target.value;

        setFilterValue(val ? val : '');

        val = val.toUpperCase();

        if (val && props.filterData) {
            let newList = [];

            for(let page = 0; page < props.filterData.pages.length; page++) {
                for (let i = 0; i < props.filterData.pages[page].data.length; i++) {
                    let current = props.filterData.pages[page].data[i];

                    if(props.excludeInActive && !current.isActive) {
                        break;
                    }

                    let value = val.toUpperCase();
                    let entryValue = current[props.filterKey].toUpperCase();
                    let strIndex = entryValue.indexOf(value);

                    if (strIndex > -1) {
                        newList.push(current);
                    }
                }
            }

            setFilterItems(newList);
        } else {
            DefaultFilterList();
        }
    }

    const DefaultFilterList = () => {
        let newList = [];

        if(props.filterData) {
            for(let page = 0; page < props.filterData.pages.length; page++) {
                for (let i = 0; i < props.filterData.pages[page].data.length; i++) {
                    const currentItem = props.filterData.pages[page].data[i];

                    if(currentItem && !(props.excludeInActive && !currentItem.isActive)) {
                        newList.push(currentItem);
                    }
                }
            }
        }

        setFilterItems(newList);
    }

    const ResetFilter = () => {
        DefaultFilterList();
        setFilterValue('');
        setFilterReset(filterReset === null ? true : !filterReset);
    }

    useEffect(() => {
        DefaultFilterList()
    }, [props.filterData]);

    return useMemo(() => ({
        filterReset,
        filterValue,
        filterItems,
        FilterData,
        ResetFilter
    }),[filterValue, filterItems, filterReset]);

}

export default useFilter
